// Click-Toggle für Mega-Trigger ohne Link.
//
// Wenn ein Top-Level-Eintrag im WP-Menü mit ACF-Toggle "Top-Level nicht
// verlinken" gepflegt ist, rendert der Walker ein <button data-mega-trigger>
// statt eines <a>. Hover öffnet das Dropdown weiterhin per CSS — Klick toggelt
// es zusätzlich, hält es offen, und schließt es bei Klick außerhalb oder ESC.
//
// Zusätzlich: Viewport-Alignment. Wenn das mittig-positionierte Dropdown
// rechts oder links aus dem Viewport rausragen würde, setzen wir per CSS-
// Variable --dd-shift eine horizontale Korrektur. --dd-bridge-pad streckt
// gleichzeitig die Hover-Brücke entsprechend, damit auch verschobene
// Dropdowns den Trigger per Hover noch erreichen.

(function () {
    'use strict';

    const OPEN_CLASS = 'is-open';
    const TRIGGER_SELECTOR = '[data-mega-trigger="true"]';
    const VIEWPORT_PAD = 16;       // Atemfeld zu Viewport-Kanten
    const BRIDGE_BUFFER = 24;      // zusätzlicher Hover-Bridge-Puffer

    // ---------- Viewport-Alignment ----------

    const alignDropdown = (dropdown) => {
        // Vorherige Verschiebung zurücksetzen, damit getBoundingClientRect()
        // die unverschobene Default-Position liefert.
        dropdown.style.removeProperty('--dd-shift');
        dropdown.style.removeProperty('--dd-bridge-pad');

        const rect = dropdown.getBoundingClientRect();
        const vw = window.innerWidth || document.documentElement.clientWidth;

        let shift = 0;
        if (rect.right > vw - VIEWPORT_PAD) {
            shift = (vw - VIEWPORT_PAD) - rect.right;            // negativ → nach links
        } else if (rect.left < VIEWPORT_PAD) {
            shift = VIEWPORT_PAD - rect.left;                    // positiv → nach rechts
        }

        if (shift !== 0) {
            dropdown.style.setProperty('--dd-shift', shift + 'px');
            // Brücke beidseitig um den Shift-Betrag verbreitern, damit der Trigger
            // (an seiner ursprünglichen Position) weiterhin unter der Bridge liegt.
            dropdown.style.setProperty('--dd-bridge-pad', (Math.abs(shift) + BRIDGE_BUFFER) + 'px');
        }
    };

    const alignAllDropdowns = () => {
        document.querySelectorAll('.nav-dropdown').forEach(alignDropdown);
    };

    let resizeRaf = 0;
    const scheduleAlign = () => {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(alignAllDropdowns);
    };

    // Initial nach Layout-Settling. Nutzt rAF, damit Webfonts ihre Größen
    // schon eingerechnet haben.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(alignAllDropdowns));
    } else {
        requestAnimationFrame(alignAllDropdowns);
    }

    window.addEventListener('resize', scheduleAlign, { passive: true });

    // Webfonts können Trigger-Breite ändern — neu messen sobald fertig.
    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
        document.fonts.ready.then(scheduleAlign);
    }

    // ---------- Click-Toggle für Trigger-only ----------

    const closeAll = (except) => {
        document.querySelectorAll('.nav-item.' + OPEN_CLASS).forEach((item) => {
            if (item === except) {
                return;
            }
            item.classList.remove(OPEN_CLASS);
            const trigger = item.querySelector(TRIGGER_SELECTOR);
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
            }
        });
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest(TRIGGER_SELECTOR);

        if (trigger) {
            event.preventDefault();
            const navItem = trigger.closest('.nav-item');
            if (!navItem) {
                return;
            }
            const isOpen = navItem.classList.toggle(OPEN_CLASS);
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            closeAll(navItem);
            return;
        }

        // Klick außerhalb eines geöffneten Mega-Items → alles schließen.
        if (!event.target.closest('.nav-item.' + OPEN_CLASS)) {
            closeAll(null);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }
        const open = document.querySelector('.nav-item.' + OPEN_CLASS);
        if (!open) {
            return;
        }
        closeAll(null);
        // Fokus zurück auf den Trigger.
        const trigger = open.querySelector(TRIGGER_SELECTOR);
        if (trigger) {
            trigger.focus();
        }
    });
})();
